import { render, staticRenderFns } from "./FiltroStatusAtendimento.vue?vue&type=template&id=28e3bd54&"
import script from "./FiltroStatusAtendimento.vue?vue&type=script&lang=js&"
export * from "./FiltroStatusAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports